import React, { Fragment } from 'react'
import i18n from '../../i18n'
import { MENU_KEYS } from '../../utils/translation-constants'
import DashboardIcon from 'custom/assets/common-icons/dashboard.svg'
import Account_DepositIcon from 'custom/assets/accounts/Deposit.svg'
import Account_Beneficiary_TransferIcon from 'custom/assets/accounts/Beneficiary_Transfer.svg'
import Account_PaymentIcon from 'custom/assets/accounts/Payment.svg'
import Account_Quick_TransferIcon from 'custom/assets/accounts/Quick_Transfer.svg'
import Account_StatementIcon from 'custom/assets/accounts/Statement.svg'
import Transfers_AddIcon from 'custom/assets/transfers/Add.svg'
import Transfers_DownloadIcon from 'custom/assets/transfers/Download.svg'
import Payments_InvoiceIcon from 'custom/assets/payments/invoice.svg'
import Payments_ReceiptsIcon from 'custom/assets/payments/receipt.svg'
import R_ChequeIcon from 'custom/assets/cheque/Cheque.svg'
import R_SIIcon from 'custom/assets/cheque/Standing_Instruction.svg'
import P_ViewBillerIcon from 'custom/assets/payments/ViewBiller.svg'
import P_ServicesIcon from 'custom/assets/payments/Services.svg'
import P_AirtimeIcon from 'custom/assets/payments/Airtime.svg'
import P_BuyDataIcon from 'custom/assets/payments/Buy_Data.svg'
import P_SchoolPaymentIcon from 'custom/assets/payments/School_Payments.svg'
import P_OtherPaymentIcon from 'custom/assets/payments/Other_Payments.svg'

export const ACCOUNT_SUB_MENUS = [
  {
    title: MENU_KEYS.STATEMENT,
    desc: MENU_KEYS.VIEWSTMT,
    icon: Account_StatementIcon,
    key: 'STATEMENTS',
    link: '/statement',
  },
  {
    title: MENU_KEYS.PAYMENTS,
    desc: MENU_KEYS.PURCHASE_AIRTIME,
    icon: Account_PaymentIcon,
    key: 'PAYMENTS',
    link: '/payments',
  },
  {
    title: MENU_KEYS.QUICK_TRANSFER,
    desc: MENU_KEYS.QUICK_FT,
    icon: Account_Quick_TransferIcon,
    key: 'QUICK_TRANSFER',
    link: '/beneficiary-transfers/quick-pay',
  },
  {
    title: MENU_KEYS.TRANSFER_TO_BENE,
    desc: MENU_KEYS.TRANSFER_MONEY_BENE,
    icon: Account_Beneficiary_TransferIcon,
    key: 'BENEFICIARY_TRANSFER',
    link: '/beneficiary-transfers/transfers',
  },

  {
    title: MENU_KEYS.DEPOSITS,
    desc: MENU_KEYS.TRANSFER_MONEY_BENE,
    icon: Account_DepositIcon,
    key: 'ACCOUNT_DEPOSITS',
    link: '/deposits',
  },

  {
    title: MENU_KEYS.CARDLESS_CASH,
    desc: MENU_KEYS.GENERATE_TOKEN_DESC,
    icon: Account_DepositIcon,
    key: 'ACCOUNT_DEPOSITS',
    link: '/accounts/cardless-cash',
  },
]

export const PAYMENTS_MENUS = [
  {
    title: MENU_KEYS.ADD_BILLER,
    desc: MENU_KEYS.SERVICE_PROVIDER_BENE,
    icon: Transfers_AddIcon,
    key: 'VIEW_BILLER',
    link: '/payments/add-biller', // '/payments/top-ups',
  },
  {
    title: MENU_KEYS.VIEW_BILLER,
    desc: MENU_KEYS.ALL_PEROVIDER_BENE,
    icon: P_ViewBillerIcon,
    key: 'VIEW_BILLER',
    link: '/payments/biller-list', // '/payments/top-ups',
  },
  {
    title: MENU_KEYS.SERVICES,
    desc: MENU_KEYS.ADD_MAKE_BILL_PAYMENT,
    icon: P_ServicesIcon,
    key: 'PRODUCT',
    link: '/payments/products/list',
  },
  {
    title: MENU_KEYS.BUY_DATA,
    desc: MENU_KEYS.BILLER_BUY_DATA,
    icon: P_BuyDataIcon,
    key: 'BUY_DATA',
    link: '/payments/buyData/list',
  },
  {
    title: MENU_KEYS.BUY_AIR,
    desc: MENU_KEYS.BILLER_BUY_AIRTIME,
    icon: P_AirtimeIcon,
    key: 'BUY_AIRTIME',
    link: '/payments/top-ups/list',
  },

  {
    title: MENU_KEYS.DOWNLOAD_RECIEPT,
    desc: MENU_KEYS.DOWNLOAD_YOUR_RECIEPT,
    icon: Transfers_DownloadIcon,
    key: 'DOWNLOAD_RECEIPTS',
    link: '/payments/download-receipt',
  },
]

export const PAYMENT_SERVICE_MENUS = [
  {
    title: MENU_KEYS.SCHOOL_PAYMENT,
    desc: MENU_KEYS.MAKE_SCHOOL_PAYMENT,
    icon: P_SchoolPaymentIcon,
    key: 'SCHOOL_PAYMENT',
    link: '/schoolPayments',
  },
  {
    title: MENU_KEYS.UTILITY_PAYMENTS,
    desc: MENU_KEYS.MAKE_OTHER_PAYMENT,
    icon: P_OtherPaymentIcon,
    key: 'OTHER_PAYMENT',
    link: '/otherPayments',
  },
]

export const REQUEST_MENUS = [
  {
    title: MENU_KEYS.CHEQUE,
    desc: MENU_KEYS.ORDER_CANCEL_CHEQUE_STATUS,
    icon: R_ChequeIcon,
    key: 'CHEQUE',
    link: '/requests/cheque',
  },
  {
    title: MENU_KEYS.SI,
    desc: MENU_KEYS.CREATE_VIEW_SI,
    icon: R_SIIcon,
    key: 'SI',
    link: '/requests/standing-instruction',
  },
]

export const REQUEST_DEBIT_CARD_MENUS = [
  {
    title: MENU_KEYS.CHANGE_CARD_PIN,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: DashboardIcon,
    key: 'CHANGE_CARD_PIN',
    link: '/requests/debit-card/change-card-pin',
  },
  {
    title: MENU_KEYS.CARD_LOAD,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: DashboardIcon,
    key: 'CARD_LOAD',
    link: '/requests/debit-card/card-load',
  },
  {
    title: MENU_KEYS.BLOCK_DEBIT_CARD,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: DashboardIcon,
    key: 'BLOCK_DEBIT_CARD',
    link: '/requests/debit-card/block-debit-card',
  },
]

export const REQUEST_SI_MENUS = [
  {
    title: MENU_KEYS.CREATE_SI,
    desc: MENU_KEYS.CREATE_SI_DESC,
    icon: R_SIIcon,
    key: 'CHANGE_CARD_PIN',
    link: '/requests/standing-instruction/create',
  },
  {
    title: MENU_KEYS.SI_VIEW,
    desc: MENU_KEYS.VIEW_SI,
    icon: R_SIIcon,
    key: 'CARD_LOAD',
    link: '/requests/standing-instruction/view',
  },
]

export const GIMACPAY_MENUS = [
  {
    title: MENU_KEYS.TRANSFERS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: R_SIIcon,
    key: 'GIMAC_TRANSFER',
    link: 'payments/payBills',
  },
  {
    title: MENU_KEYS.PAYMENTS,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: R_SIIcon,
    key: 'GIMAC_PAYMENT',
    link: 'payments/payBills',
  },
  {
    title: MENU_KEYS.ATM_PROVISION,
    desc: MENU_KEYS.DESCRIPTION_HERE,
    icon: R_SIIcon,
    key: 'GIMAC_ATM',
    link: 'payments/payBills',
  },
]
